  <!-- <div class="modal" [ngClass]="{'show': this.openInfo}" *ngIf="this.company">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header" style="justify-content: space-between;">
          <h1 class="modal-title fs-5" id="staticBackdropLabel" style="font-size: 17px !important;">Sobre o estabelecimento</h1>
          <div class="d-flex align-items-center icon-modal" (click)="this.close()">
            <button type="button" class="btn-close"></button>
          </div>
        </div>
        <div class="modal-body" style="padding: 0;">
          <div class="description-company">
            <div class="header-company">
              <div style="display: flex; justify-content: center; align-items: center;">
                <div class="div-company__logo" style="width: 70px; height: 70px; border-radius: 40px;background-size: cover; border: 1px solid #e7e7e7;" [ngStyle]="{'background-image': 'url('+ this.company.company.logo +')'}"></div>
              </div>
              <div class="header-company__name">{{ this.company.company.companyName }}</div>
              <div style="text-align: center;" *ngIf="!this.readOnlyState">
                <span class="span-button" *ngIf="this.company.configs.minValue != 0 && !this.local && !this.localCounter">Pedido mínimo {{ this.company.configs.minValue | currency: 'BRL' }}</span>
              </div>
              <div class="box-number-phone">
                
                <span class="number-phone-company"><div class="icon-phone"></div> {{ this.company.company.phoneCompany }}</span>
              </div>
            </div>
            <div class="description-first" *ngIf="this.company.company.description !== ''">
              <div class="header-box-infos">
                <div>
                  <span class="title-info" style="padding-left: 10px;">Descrição</span>
                </div>
              </div>
              <div class="description-body" style="border-bottom: 0;">
                <span class="span-info">{{ this.company.company.description }}</span>
              </div>
            </div>
            <div class="description-first">
              <div class="header-box-infos">
                <div>
                  <span class="title-info" style="padding-left: 10px;">Formas de pagamento</span>
                </div>
              </div>
              <div class="description-body" style="border-bottom: 0;" *ngIf="this.company">
                <ng-container *ngFor="let form of this.company.company.paymentForms">
                  <div style="gap: 10px;">
                    <div class="card__choice__option__icon" [ngSwitch]="form.icon">
                      <i *ngSwitchCase="1"><img src="../../../assets/icons//method-payment/dinheiro.png"  style="width: 25px;"/></i>
                      <i *ngSwitchCase="2"><img src="../../../assets/icons/method-payment/generic-card-1.png"  style="width: 25px;"/></i>
                      <i *ngSwitchCase="3"><img src="../../../assets/icons/method-payment/generic-card-2.png"  style="width: 25px;"/></i>
                      <i *ngSwitchCase="4"><img src="../../../assets/icons/method-payment/mastercard-card.png"  style="width: 25px;"/></i>
                      <i *ngSwitchCase="5"><img src="../../../assets/icons/method-payment/visa-card.png"  style="width: 25px;"/></i>
                      <i *ngSwitchCase="6"><img src="../../../assets/icons/method-payment/pix.png"  style="width: 25px;"/></i>
                      <i *ngSwitchCase="7"><img src="../../../assets/icons/method-payment/american-express.png"  style="width: 25px;"/></i>
                      <i *ngSwitchCase="8"><img src="../../../assets/icons/method-payment/vr-card.png"  style="width: 25px;"/></i>
                      <i *ngSwitchDefault><img src="../../../assets/icons/method-payment/generic-card-1.png"  style="width: 25px;"/></i>
                  </div>
                    <span>{{ form.formName }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
            <ng-container *ngIf="!this.readOnlyState">
              <ng-container *ngIf="!this.local">
                <div class="description-first" *ngIf="timesInfo.delivery.active || timesInfo.counter.active">
                  <div class="header-box-infos">
                    <div>
                      <span class="title-info" style="padding-left: 10px;">Tempo de preparo</span>
                    </div>
                  </div>
                  <div class="description-body" style="border-bottom: 0;">
                    <div style="justify-content: space-between;" *ngIf="!this.localCounter && timesInfo.delivery.active">
                      <span class="span-button" style="margin-bottom: 2px;">Entrega</span>
                      <span class="span-button" style="margin-bottom: 2px;">{{ timesInfo.delivery.label  }}</span>
                    </div>
                    <div style="justify-content: space-between;" *ngIf="timesInfo.counter.active">
                      <span class="span-button" style="margin-bottom: 2px;">Retirada</span>
                      <span class="span-button" style="margin-bottom: 2px;">{{ timesInfo.counter.label  }}</span>
                    </div>
                  </div>
                </div>
              </ng-container>
            </ng-container>


            <div class="description-first">
              <div class="header-box-infos">
                <div>
                  <span class="title-info" style="padding-left: 10px;">Horário de atendimento</span>
                </div>
              </div>
              <div class="description-body" style="border-bottom: none;">
                <div class="opening" *ngIf="this.opening">
                  <ng-container *ngIf="this.opening.sunday == 1">
                    <div class="day-opening">
                      <span>Domingo</span>
                      <span>{{ opening.opensunday.substring(0, 5) }} às {{ opening.closesunday.substring(0, 5) }}</span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="this.opening.monday == 1">
                    <div class="day-opening">
                      <span>Segunda-feira</span>
                      <span>{{ opening.openmonday.substring(0, 5) }} às {{ opening.closemonday.substring(0, 5) }}</span>
                    </div>

                  </ng-container>

                  <ng-container *ngIf="this.opening.tuesday == 1">
                    <div class="day-opening">
                      <span>Terça-feira</span>
                      <span>{{ opening.opentuesday .substring(0, 5)}} às {{ opening.closetuesday.substring(0, 5) }}</span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="this.opening.wednesday == 1">
                    <div class="day-opening">
                      <span>Quarta-feira</span>
                      <span>{{ opening.openwednesday.substring(0, 5) }} às {{ opening.closewednesday.substring(0, 5) }}</span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="this.opening.thursday == 1">
                    <div class="day-opening">
                      <span>Quinta-feira</span>
                      <span>{{ opening.openthursday.substring(0, 5) }} às {{ opening.closethursday.substring(0, 5) }}</span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="this.opening.friday == 1">
                    <div class="day-opening">
                      <span>Sexta-feira</span>
                      <span>{{ opening.openfriday.substring(0, 5) }} às {{ opening.closefriday.substring(0, 5) }}</span>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="this.opening.saturday == 1">
                    <div class="day-opening">
                      <span>Sabado</span>
                      <span>{{ opening.opensaturday.substring(0, 5) }} às {{ opening.closesaturday.substring(0, 5) }}</span>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>
            <div class="description-first">
              <div >
                <div style="border-top: 1px solid #cfcfcf; padding-top: 10px;">
                  <span class="title-info" style="padding-left: 10px;">Endereço</span>
                </div>
              </div>
              <div class="description-body" style="border-bottom: 0;">
                <div style="margin-bottom: 10px;" class="address-link">
                  <ng-container *ngIf="this.addressCompany">
                    <span>{{this.addressCompany.street + ", " + this.addressCompany.number + " - " + this.addressCompany.district + ", " +  this.addressCompany.city + " - " + this.addressCompany.state + ", " + this.addressCompany.country + ", " + this.addressCompany.postalCode}}</span>
                  </ng-container>
                  <a [href]="this.addressUrl" target="_blank">
                    <div class="icon-container-arrow">
                      <i class="icon-chevron-right" aria-hidden="true"></i>
                    </div>
                  </a>
                </div>
                <app-mapa [company]="this.company"></app-mapa>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->


<ng-container *ngIf="this.openInfo">
  <div class="box-off-canva" [ngClass]="{'open': this.openInfo}" (click)="closeOffCanvas()"></div>
  <div class="offcanvas offcanvas-bottom" *ngIf="this.company" tabindex="-1" [ngClass]="{'show': openInfo}" style="height: fit-content; z-index: 120;" [ngStyle]="{'height': offCanvasHeight + 'px', 'z-index': 120}" #offCanva>
    <div 
      class="header-info"tabindex="-1" 
      [ngClass]="{'show': openInfo}"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()"
      (mousedown)="onTouchStart($event)"
      (mousemove)="onTouchMove($event)"
      (mouseup)="onTouchEnd()"
    >
      <div></div>
    </div>
    <div class="offcanvas-body"
      (touchstart)="onTouchStart($event)"
      (touchmove)="onTouchMove($event)"
      (touchend)="onTouchEnd()"
      (mousedown)="onTouchStart($event)"
      (mousemove)="onTouchMove($event)"
      (mouseup)="onTouchEnd()"
    >
      <div class="content-offCanva">
        <div class="content-title-offCanva"> 
          <span class="title-offCanva">Detalhes da loja</span>
          <!-- <span class="info-offCanva">Escolha o horário para receber o seu pedido</span> -->
        </div>
        <div class="description-company">
          <div class="header-company">
            <div style="display: flex; justify-content: center; align-items: center;">
              <div class="div-company__logo" style="width: 70px; height: 70px; border-radius: 40px;background-size: cover; border: 1px solid #e7e7e7;" [ngStyle]="{'background-image': 'url('+ this.company.company.logo +')'}"></div>
            </div>
            <div class="header-company__name">{{ this.company.company.companyName }}</div>
            <div style="text-align: center;" *ngIf="!this.readOnlyState">
              <span class="span-button" *ngIf="this.company.configs.minValue != 0 && !this.local && !this.localCounter">Pedido mínimo {{ this.company.configs.minValue | currency: 'BRL' }}</span>
            </div>
            <div class="box-number-phone">
              
              <span class="number-phone-company"><div class="icon-phone"></div> {{ this.company.company.phoneCompany }}</span>
            </div>
          </div>
          <!--Descrição-->
          <div class="description-first" *ngIf="this.company.company.description !== ''">
            <div class="header-box-infos">
              <div>
                <span class="title-info" style="padding-left: 10px;">Descrição</span>
              </div>
            </div>
            <div class="description-body" style="border-bottom: 0;">
              <span class="span-info">{{ this.company.company.description }}</span>
            </div>
          </div>
          <!--Formas de pagamento-->
          <div class="description-first">
            <div class="header-box-infos">
              <div>
                <span class="title-info" style="padding-left: 10px;">Formas de pagamento</span>
              </div>
            </div>
            <div class="description-body" style="border-bottom: 0;" *ngIf="this.company">
              <ng-container *ngFor="let form of this.company.company.paymentForms">
                <div style="gap: 10px;">
                  <div class="card__choice__option__icon" [ngSwitch]="form.icon">
                    <i *ngSwitchCase="1"><img src="../../../assets/icons//method-payment/dinheiro.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="2"><img src="../../../assets/icons/method-payment/generic-card-1.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="3"><img src="../../../assets/icons/method-payment/generic-card-2.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="4"><img src="../../../assets/icons/method-payment/mastercard-card.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="5"><img src="../../../assets/icons/method-payment/visa-card.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="6"><img src="../../../assets/icons/method-payment/pix.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="7"><img src="../../../assets/icons/method-payment/american-express.png"  style="width: 25px;"/></i>
                    <i *ngSwitchCase="8"><img src="../../../assets/icons/method-payment/vr-card.png"  style="width: 25px;"/></i>
                    <i *ngSwitchDefault><img src="../../../assets/icons/method-payment/generic-card-1.png"  style="width: 25px;"/></i>
                </div>
                  <span>{{ form.formName }}</span>
                </div>
              </ng-container>
            </div>
          </div>
          <!--Tempo de Preparo-->
          <ng-container *ngIf="!this.readOnlyState">
            <ng-container *ngIf="!this.local">
              <div class="description-first" *ngIf="timesInfo.delivery.active || timesInfo.counter.active">
                <div class="header-box-infos">
                  <div>
                    <span class="title-info" style="padding-left: 10px;">Tempo de preparo</span>
                  </div>
                </div>
                <div class="description-body" style="border-bottom: 0;">
                  <div style="justify-content: space-between;" *ngIf="!this.localCounter && timesInfo.delivery.active">
                    <span class="span-button" style="margin-bottom: 2px;">Entrega</span>
                    <span class="span-button" style="margin-bottom: 2px;">{{ timesInfo.delivery.label  }}</span>
                  </div>
                  <div style="justify-content: space-between;" *ngIf="timesInfo.counter.active">
                    <span class="span-button" style="margin-bottom: 2px;">Retirada</span>
                    <span class="span-button" style="margin-bottom: 2px;">{{ timesInfo.counter.label  }}</span>
                  </div>
                </div>
              </div>
            </ng-container>
          </ng-container>


          <!--Horário de funcionamento-->
          <div class="description-first">
            <div class="header-box-infos">
              <div>
                <span class="title-info" style="padding-left: 10px;">Horário de atendimento</span>
              </div>
            </div>
            <div class="description-body" style="border-bottom: none;">
              <div class="opening" *ngIf="this.opening">
                <ng-container *ngIf="this.opening.sunday == 1">
                  <div class="day-opening">
                    <span>Domingo</span>
                    <span>{{ opening.opensunday.substring(0, 5) }} às {{ opening.closesunday.substring(0, 5) }}</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="this.opening.monday == 1">
                  <div class="day-opening">
                    <span>Segunda-feira</span>
                    <span>{{ opening.openmonday.substring(0, 5) }} às {{ opening.closemonday.substring(0, 5) }}</span>
                  </div>

                </ng-container>

                <ng-container *ngIf="this.opening.tuesday == 1">
                  <div class="day-opening">
                    <span>Terça-feira</span>
                    <span>{{ opening.opentuesday .substring(0, 5)}} às {{ opening.closetuesday.substring(0, 5) }}</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="this.opening.wednesday == 1">
                  <div class="day-opening">
                    <span>Quarta-feira</span>
                    <span>{{ opening.openwednesday.substring(0, 5) }} às {{ opening.closewednesday.substring(0, 5) }}</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="this.opening.thursday == 1">
                  <div class="day-opening">
                    <span>Quinta-feira</span>
                    <span>{{ opening.openthursday.substring(0, 5) }} às {{ opening.closethursday.substring(0, 5) }}</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="this.opening.friday == 1">
                  <div class="day-opening">
                    <span>Sexta-feira</span>
                    <span>{{ opening.openfriday.substring(0, 5) }} às {{ opening.closefriday.substring(0, 5) }}</span>
                  </div>
                </ng-container>

                <ng-container *ngIf="this.opening.saturday == 1">
                  <div class="day-opening">
                    <span>Sabado</span>
                    <span>{{ opening.opensaturday.substring(0, 5) }} às {{ opening.closesaturday.substring(0, 5) }}</span>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
          <!--Endereço-->
          <div class="description-first">
            <div class="header-box-infos">
              <div>
                <span class="title-info" style="padding-left: 10px;">Endereço</span>
              </div>
            </div>

            <div class="description-body" style="border-bottom: 0;">
              <div style="margin-bottom: 10px;" class="address-link">
                <ng-container *ngIf="this.addressCompany">
                  <span>{{this.addressCompany.street + ", " + this.addressCompany.number + " - " + this.addressCompany.district + ", " +  this.addressCompany.city + " - " + this.addressCompany.state + ", " + this.addressCompany.country + ", " + this.addressCompany.postalCode}}</span>
                </ng-container>
                <a [href]="this.addressUrl" target="_blank">
                  <div class="icon-container-arrow">
                    <i class="icon-chevron-right" aria-hidden="true"></i>
                  </div>
                </a>
              </div>
              <app-mapa [company]="this.company"></app-mapa>
            </div>
          </div>
        </div>
      </div>
      <div class="button-offCanva">
        <button (click)="closeOffCanvas()">Fechar</button>
      </div>
    </div>
  </div>
</ng-container>
